import {timeout300} from '~/utils/timeout';

export const HeaderSearchResult = {
    props: ['title'],
    data: () => ({
        blockState: 'hidden',
    }),
    computed: {
        isVisible: function () {
            return this.blockState === 'visible';
        },
    },
    methods: {
        show() {
            return new Promise(resolve => {
                if (this.isVisible)
                    return;

                this.blockState = 'transition';
                timeout300(() => {
                    this.blockState = 'visible';
                    resolve();
                });
            });
        },
        hide() {
            return new Promise(resolve => {
                if (!this.isVisible)
                    return;

                this.blockState = 'transition';
                this.$nextTick(() =>
                    this.$el.addEventListener('transitionend', () => {
                        this.blockState = 'hidden';
                        resolve();
                    }, {once: true})
                );
            });
        },
    },
    render() {
        return (
            <div class="header-search__result" data-block-state={this.blockState}>
                <div class="header-search__result-content">
                    {this.title ? (
                        <div class="header-search__result-title">{this.title}</div>
                    ) : null}
                    <div class="header-search__result-list">
                        {this.$slots.default}
                    </div>
                </div>
            </div>
        );
    }
}
